var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconTableContents = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 31,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.992 4.008h23.295V.68H.992v3.328Zm0 6.655h23.295V7.335H.992v3.328Zm0 6.656h23.295V13.99H.992v3.328Zm26.623 0h3.328V13.99h-3.328v3.328Zm0-16.64v3.329h3.328V.68h-3.328Zm0 9.984h3.328V7.335h-3.328v3.328Z",
  fill: "#666"
})));

export default SvgIconTableContents;